module.exports = __webpack_public_path__ + "static/img/carpic_1.9340b04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carpic_1.png
// module id = 752
// module chunks = 1